import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { GET_MANAGE_BOOKING_DATA_RESET } from "../Constants/Constants";
import { canAccessMultiPccTicketReport } from "../constants/accessControl";

export default function Home(props) {
  // const token = JSON.parse(localStorage.getItem("userInfo"));
  const { decodedToken, checkUserPermission } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInEmail =
    decodedToken?.email || localStorage.getItem("user_email") || "";
  const hasMultiPccTicketReportEmailAccess = canAccessMultiPccTicketReport(
    loggedInEmail
  );

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);
  const productCardSx = {
    width: "100%",
    height: 110,
    display: "flex",
  };
  const productButtonSx = {
    color: "black",
    fontSize: 16,
    lineHeight: 1.2,
    width: "100%",
    height: "100%",
    "&:hover": {
      backgroundColor: "#282828",
      color: "white",
    },
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box sx={{ mt: 10 }}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Typography
              sx={{
                fontSize: 30,
                textAlign: "center",
                ml: 3,
                color: "#313639",
              }}
            >
              Welcome to Agent Portal
            </Typography>
          </Grid>
          <Grid sx={{ margin: 3, fontSize: 20, marginTop: 6 }} xs={12}>
            Manage Users
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Grid>
          <Grid
            xs={12}
            sx={{
              marginLeft: 3,
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            {hasAccess(["superuser"]) && (
              <Paper
                elevation={6}
                sx={{ width: "20%", height: "130%", marginRight: 2 }}
              >
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/manageusers");
                  }}
                >
                  Manage Users
                </Button>
              </Paper>
            )}
            {hasAccess(["superuser", "admin", "user"]) && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/profile");
                  }}
                >
                  Profile
                </Button>
              </Paper>
            )}
          </Grid>
          <Grid sx={{ margin: 3, fontSize: 20, marginTop: 10 }} xs={12}>
            Manage Customers
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Grid>
          <Grid
            xs={12}
            sx={{
              marginLeft: 3,
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            {hasAccess(["superuser", "admin", "user"]) && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/managecustomer");
                  }}
                >
                  Customers
                </Button>
              </Paper>
            )}
            {checkUserPermission(105, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/managecustomerlogins");
                  }}
                >
                  Customer Logins
                </Button>
              </Paper>
            )}
          </Grid>
          <Grid sx={{ margin: 3, fontSize: 20, marginTop: 10 }} xs={12}>
            Manage Products
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Grid>
          <Grid
            xs={12}
            sx={{
              marginLeft: 3,
              display: "flex",
              gap: 8,
            }}
          >
            {checkUserPermission(106, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={productButtonSx}
                  onClick={() => {
                    navigate("/hxCancellationRules");
                  }}
                >
                  HX Killer
                </Button>
              </Paper>
            )}
            {checkUserPermission(106, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/agencyBookingReportRules");
                  }}
                >
                  Agency Booking Report
                </Button>
              </Paper>
            )}
             {checkUserPermission(107, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/scheduleChangeRules");
                  }}
                >
                  Schedule Change
                </Button>
              </Paper>
            )}
            {checkUserPermission(102, "can_view") && (
              <Paper
                elevation={6}
                sx={{ width: "20%", height: "130%", marginRight: 2 }}
              >
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    dispatch({ type: GET_MANAGE_BOOKING_DATA_RESET });
                    navigate("/managemyitinerary");
                  }}
                >
                  Manage My Itinerary
                </Button>
              </Paper>
            )}
            {/* {checkUserPermission(103, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/ticketreport");
                  }}
                >
                  Ticket Report
                </Button>
              </Paper>
            )} */}
            {/* {checkUserPermission(103, "can_view") &&
              hasNewTicketReportEmailAccess && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/newticketreport");
                  }}
                >
                  New Ticket Report
                </Button>
              </Paper>
            )} */}
            {/* {checkUserPermission(103, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,S
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/newticketreport");
                  }}
                >
                  New Ticket Report
                </Button>
              </Paper>
            )} */}
            {checkUserPermission(103, "can_view") &&
             (
                <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                  <Button
                    sx={{
                      // backgroundColor: "#282828",
                      color: "black",
                      fontSize: 18,
                      width: "100%",
                      height: "100%",
                      "&:hover": {
                        backgroundColor: "#282828",
                        color: "white",
                      },
                    }}
                    onClick={() => {
                      navigate("/multipccticketreport");
                    }}
                  >
                    Ticket Report
                  </Button>
                </Paper>
              )}
            {checkUserPermission(101, "can_view") && (
              <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
                <Button
                  sx={{
                    // backgroundColor: "#282828",
                    color: "black",
                    fontSize: 18,
                    width: "100%",
                    height: "100%",
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/viewlogs");
                  }}
                >
                  View Logs
                </Button>
              </Paper>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
